

































import LoadingAlert from "@/components/shared/LoadingAlert.vue";
import { ReceiptImportFile } from "@/models/ReceiptImportFile";
import { useHttpCore } from "@/plugins/axios";
import { useSelectingPharmacyStore } from "@/store/selectingPharmacyStore";
import { computed, defineComponent, ref, watch } from "@vue/composition-api";

export default defineComponent({
  components: { LoadingAlert },
  setup() {
    const httpCore = useHttpCore();

    const selectingPharmacyStore = useSelectingPharmacyStore();
    const myPharmacyId = selectingPharmacyStore.selectingPharmacyId;

    const isFirstLoading = ref<boolean>(true);
    const isLoading = ref<boolean>(false);
    const query = ref<string>("");
    const files = ref<Array<ReceiptImportFile>>([]);
    const fields = [
      { key: "file_name", label: "ファイル名" },
      { key: "status", label: "状況" },
      { key: "created_at", label: "アップロード日" },
    ];
    const sorter = { external: true, resetable: false };
    const sorterValue = ref<Record<string, string | boolean>>({ column: "created_at", asc: false });
    const sorterField = computed(() => (sorterValue.value.asc ? sorterValue.value.column : `-${sorterValue.value.column}`));

    const currentPage = ref<number>(1);
    const totalPages = ref<number>(1);
    const totalCount = ref<number>(0);

    async function fetchReceipts() {
      if (isLoading.value) return;
      if (!myPharmacyId.value) return;

      try {
        isLoading.value = true;
        const req_params = { 
          page: currentPage.value,
          query: query.value,
          sort: sorterField.value,
        };

        const response = await httpCore.get(`/api/v2/pharmacy/pharmacies/${myPharmacyId.value}/receipt_import_files`, { params: req_params });
        files.value = response.data.map((d: Record<string, unknown>) => new ReceiptImportFile(d));
        currentPage.value = Number(response.headers["x-current-page"]);
        totalPages.value = Number(response.headers["x-total-pages"]);
        totalCount.value = Number(response.headers["x-total-count"]);
        isFirstLoading.value = false;
      } finally {
        isLoading.value = false;
      }
    }

    watch(currentPage, () => fetchReceipts());
    watch(sorterValue, () => fetchReceipts());
    watch(myPharmacyId, () => fetchReceipts());
    fetchReceipts();

    return {
      isFirstLoading,
      isLoading,
      query,
      files,
      fields,
      sorter,
      sorterValue,
      currentPage,
      totalPages,
      totalCount,
    };
  },
});
